import { Controller } from "@hotwired/stimulus"

// 公務所フォームの郵便番号→住所補完。モーダルは Turbo Stream で差し込まれ
// turbo:load が発火しないため、以前 places.js の turbo:load で初期化していた
// jpostal をフォーム自身に接続する Stimulus へ移す。
export default class extends Controller {
  connect() {
    window.jpostalPreservingInput("#place_postal_code", {
      postcode: ["#place_postal_code"],
      address: {
        "#place_address": "%3%4%5%6%7"
      }
    })
  }
}
